module.exports = __webpack_public_path__ + "static/media/(DH)_MG_5949-bijuterias.747876e8.jpg";